<template>
  <div>
    <!-- <div style="padding:0px 20px;" class="tar cursor-poiner">
      <span @click="orgination">{{orgName}}</span>
    </div>-->
    <!-- 列表 -->
    <div class="mob_list">
      <!-- <el-checkbox-group v-model="checkedList"> -->
      <ul v-if="videoList.length !== 0">
        <li class="top-li" v-for="item in videoList" :key="item.id">
          <el-checkbox @change="handleCheckedCitiesChange" v-show="isShowCheck" :label="item">
            <div></div>
          </el-checkbox>
          <div class="li-box">
            <div @click="selectDetail(item.id)" class="li-img" style="vertical-align:middle;">
              <el-image fit="cover" :src="item.fileLocation"></el-image>
            </div>
            <div class="li-text" style="width:200px;">
              <h3 class="red">{{item.fileName}}</h3>
              <div>相关人物：{{item.personName}}</div>
              <div
                class="text-color f14"
              >类别：{{item.videoType == 1 ?'成片库':'素材库'}} / 格式：{{item.fileType}}</div>
              <div class="text-color f14">时长：{{item.filePlayTime}}</div>
              <div class="tar" v-if="isShowCan">
                <el-button
                  class="f12"
                  @click="cancelFavorite(item.id)"
                  style="padding:5px 10px;"
                  size="mini"
                >取消收藏</el-button>
                <span v-show="item.status == 0">已下架</span>
              </div>
            </div>
          </div>
          <div v-show="item.status == 0" class="maskbox"></div>
        </li>

      </ul>
      <div v-else style="padding:30px;" class="tac">{{textword}}</div>
      <!-- </el-checkbox-group> -->
    </div>
    <div>
      <!-- 底部 -->
      <div v-if="isShowCheck" class="collFooter">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
        >全选</el-checkbox>
        <div>
          <el-button size="mini">取消收藏</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      checkedList: [],
      isShowCheck: false,
      orgName: "管理",
      checkAll: false,
      isIndeterminate: true,
      checkId: ""
    };
  },
  props: {
    videoList: Array,
    textword: "",
    isShowCan: false
  },
  methods: {
    selectDetail: async function(id) {
      //   this.$router.push("/mobvideodetail");
      var res = await this.$http.post(`/v1/videoInfo/videoStatus?id=${id}`);
      var { code, message, data } = res.data;
      if (code == 0) {
        this.$router.push({
          path: "/mobvideodetail",
          query: {
            id: id,
            status: 0
          }
        });
      } else {
        this.$layer.toast({
          icon: "icon-check", // 图标clssName 如果为空 toast位置位于下方,否则居中
          content: message,
          time: 1000 // 自动消失时间 toast类型默认消失时间为2000毫秒
        });
      }
    },
    orgination: function() {
      if (this.isShowCheck) {
        this.isShowCheck = false;
        this.orgName = "管理";
      } else {
        this.isShowCheck = true;
        this.orgName = "完成";
      }
    },
    handleCheckAllChange(val) {
      console.log(val);
      this.checkedList = val ? this.videoList : [];
      this.isIndeterminate = false;
    },
    handleCheckedCitiesChange: function(value) {
      console.log(this.checkedList);
      console.log(value);
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.videoList.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.videoList.length;
    },
    cancelFavorite: function(id) {
      this.$emit("cancelCollect", id);
    }
  }
};
</script>

<style lang="scss" scoped>
.mob_list {
  background-color: #fff;
  margin-top: 20px;
  .top-li {
    position: relative;
    display: flex;
    flex-direction: row;
    padding: 20px 0px;
    border-bottom: 1px solid #dddddd;
    // margin: 0px 10px;

    // vertical-align: middle;
    // justify-content: center;
    .li-box {
      display: flex;
      flex-direction: row;
      vertical-align: middle;
    }
    .li-img {
      // position: relative;
      //   .li-num {
      //     width: 30px;
      //     height: 26px;
      //     border-radius: 5px 0 5px 0;
      //     // background-color: #f5a623;
      //     // background-color: #c1c7ce;

      //     left: 0px;
      //     top: 0px;
      //     position: absolute;
      //     text-align: center;
      //     color: #fff;
      //     font-size: 20px;
      //   }
    }
    .el-image {
      width: 135px;
      height: 96px;
      border-radius: 5px;
    }
    .li-text {
      padding: 0 10px;
      h3 {
        text-align: left;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        line-clamp: 1;
        -webkit-box-orient: vertical;
      }
    }
  }
}
.collFooter {
  position: fixed;
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  height: 60px;
  line-height: 60px;
  background-color: #fff;
  width: 100%;
  z-index: 9999;
  bottom: 0px;
}
.maskbox {
  position: absolute;
  top: 0px;
  border-radius: 5px;
  background: rgba(0,0,0, 0.1);
  width: 100%;
  height: 142px;
  z-index: 2000;
}
</style>
<style>
.mob_list .top-li .el-checkbox__input {
  vertical-align: top !important;
}
</style>


// WEBPACK FOOTER //
// src/components/common/moblist.vue